import { render, staticRenderFns } from "./CarRecommender.vue?vue&type=template&id=740c05d8&scoped=true&lang=pug&"
import script from "./CarRecommender.vue?vue&type=script&lang=js&"
export * from "./CarRecommender.vue?vue&type=script&lang=js&"
import style0 from "./CarRecommender.vue?vue&type=style&index=0&id=740c05d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740c05d8",
  null
  
)

export default component.exports